module.exports = __webpack_public_path__ + "static/img/no-data.be8df3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/no-data.png
// module id = 8FBZ
// module chunks = 84